// Copyright (c) 2021 Deere & Company

import './modal.scss';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import React from 'react';

export const ModalBase = props => (
    <div className="modal-base">
        <Modal
            backdrop="static"
            dialogClassName={props.className}
            keyboard={true}
            onHide={props.onHide}
            show={props.isOpen}
            size={props.size}
        >
            <Modal.Header>{props.header}</Modal.Header>
            <Modal.Body>{props.body}</Modal.Body>
            {props.footer && <Modal.Footer>{props.footer}</Modal.Footer>}
        </Modal>
    </div>
);

ModalBase.propTypes = {
    body: PropTypes.node.isRequired,
    className: PropTypes.string,
    footer: PropTypes.node,
    header: PropTypes.node.isRequired,
    onHide: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    size: PropTypes.string
};

ModalBase.defaultProps = {
    className: 'atp-modal',
    size: 'md'
};
